import { reactive } from 'vue';

export const loading = reactive({
  value: false
});